<template>

    <v-footer :absolute=true color="grey-darken-4" class="mt-5">
      <v-row justify="center" no no-gutters>
        <v-col class="text-center mt-4" cols="6">
          {{ new Date().getFullYear()}} - Copyright © <strong>Certh/CPERI</strong>
        </v-col>
        <v-col cols="6">
          <img class="imgFooter" src="@assets/images/logos/transparent/logo-eu-new2.png">
        </v-col>
      </v-row>

    </v-footer>

</template>

<script setup>

</script>

<style>
  .imgFooter{
    width: 200px;
    height: 60px;
  }
</style>